var _ = require('underscore');
var Base = require('front/components/Base/Base');

var template = require('./TopNav.jinja');
require('./TopNav.less');

var TopNavDesktop = require('front/components/TopNav/TopNavDesktop');
var TopNavMobile = require('front/components/TopNav/TopNavMobile');

module.exports = Base.extend({

    template: template,

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'TopNavDesktop': {selector: '.TopNav-desktopWrapper', viewConstructor: TopNavDesktop},
        'TopNavMobile': {selector: '.TopNav-mobileWrapper', viewConstructor: TopNavMobile}
    },


    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);

        this.viewsRegistration();
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/TopNav/TopNav.js
// module id = 143
// module chunks = 0